import classNames from 'classnames';
import {
  type AllHTMLAttributes,
  type ElementType,
  forwardRef,
  type ReactNode,
} from 'react';

import styles from './Text.module.css';

type TextSize = 'huge' | 'x-lg' | 'lg' | 'x-bg' | 'bg' | 'md' | 'sm' | 'x-sm';

type TextWeight = 'regular' | 'semibold' | 'bold';

export interface TextProps extends Omit<AllHTMLAttributes<HTMLElement>, 'as'> {
  as?: ElementType;
  fontSize?: TextSize;
  weight?: TextWeight;
  includePadding?: boolean;
  children?: ReactNode;
}

export const Text = forwardRef<HTMLElement, TextProps>(function Text(
  {
    as,
    fontSize = 'md',
    weight = 'regular',
    includePadding = false,
    children,
    className,
    ...rest
  },
  ref
) {
  const Component = (as ?? 'p') as ElementType;

  return (
    <Component
      ref={ref}
      className={classNames(
        styles.base,
        styles[fontSize],
        styles[weight],
        includePadding && styles.withPadding,
        className
      )}
      {...rest}
    >
      {children}
    </Component>
  );
});
